<template >
    <div>
        <b-modal ref="hojaDeVida" size="lg" hide-footer no-close-on-backdrop title="Hoja de vida">
            <Loading v-if="loader" />
        </b-modal>
    </div>
</template>
<script>
    import axios from 'axios';
    import Loading from '../Loader/Loading.vue';

    export default {
        components: {
            Loading
        },
        data() {
            return {
                content: '',
                id: null,
                loader: true,
                unidad: {},
            }
        },
        methods: {
            async editPdf() {
                try {
                    const response = await axios.get(`api/unidades-print-hv/${this.unidad.id}`, {
                        headers: {"Authorization": `Bearer ${this.$store.state.user.token}`},
                        responseType: 'blob', // Recibir el PDF como Blob
                    });
                    // console.log(response.data)
                    // Crear un enlace para descargar el PDF
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    
                    // Obtener la fecha de hoy en formato YYYY-MM-DD
                    const fechaHoy = new Date().toISOString().split('T')[0];
                    
                    link.setAttribute('download', `hv_${this.unidad.cbi}_${fechaHoy}.xlsx`); // Nombre del archivo con fecha
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.$refs['hojaDeVida'].hide();
                    this.loader = false;
                } catch (error) {
                    console.error('Error al descargar el XLSX:', error);
                }
            },
            showModal(unidad){
                this.loader = true;
                this.unidad = unidad;
                this.$refs['hojaDeVida'].show()
                this.editPdf();
            }
        },
    }
</script>